module.exports = __webpack_public_path__ + "img/ks-Property-Legacy-Plan-Sales-Tool.8df75f25.jpg";